import { useNotification } from '@/containers'

const FacebookMessenger = ({ className = '' }: { className?: string }) => {
  const { systemConfig } = useNotification()
  return (
    <div
      className={`${className} fixed bottom-[100px] right-[40px] z-[9999] flex h-[50px] w-[50px] items-center justify-center rounded rounded-full text-[40px] shadow-xl transition-all duration-200 ease-in-out`}
    >
      <a href={systemConfig?.companyMessenger} target='_blank' rel='noreferrer'>
        <svg
          fill='currentColor'
          viewBox='-149.1 -248.49675 1292.2 1490.9805'
          className='css-9w5ue6'
          height={60}
          width={60}
          xmlns='http://www.w3.org/2000/svg'
        >
          <g transform='translate(-15 -11.5)'>
            <linearGradient
              y2='1005.5'
              x2={512}
              y1='11.5'
              x1={512}
              gradientUnits='userSpaceOnUse'
              id='a'
            >
              <stop offset={0} stopColor='#00b2ff' />
              <stop offset={1} stopColor='#006aff' />
            </linearGradient>
            <path
              d='M512 11.5c-280 0-497 205.1-497 482.1 0 144.9 59.4 270.1 156.1 356.6 8.1 7.3 13 17.4 13.4 28.3l2.7 88.4c.9 28.2 30 46.5 55.8 35.2l98.6-43.5c8.4-3.7 17.7-4.4 26.5-2 45.3 12.5 93.6 19.1 143.9 19.1 280 0 497-205.1 497-482.1S792 11.5 512 11.5z'
              fill='url(#a)'
              fillRule='evenodd'
              clipRule='evenodd'
            />
            <path
              d='M213.6 634.6l146-231.6c23.2-36.8 73-46 107.8-19.9l116.1 87.1c10.7 8 25.3 7.9 35.9-.1l156.8-119c20.9-15.9 48.3 9.2 34.2 31.4L664.5 614c-23.2 36.8-73 46-107.8 19.9l-116.1-87.1c-10.7-8-25.3-7.9-35.9.1L247.8 666c-20.9 15.9-48.3-9.2-34.2-31.4z'
              fillRule='evenodd'
              clipRule='evenodd'
              fill='#fff'
            />
          </g>
        </svg>
      </a>
    </div>
  )
}
export default FacebookMessenger
